import { toDocId, toRefValue } from "./ids";

/**
 * Pure builder for the task document created when converting an action to a
 * task. Mirrors Android's startConvertingActionToTask: the new task takes the
 * action's label and inherits the parent task's project and taskState. Returns
 * null when there's no parent or the label is empty/whitespace (Android does
 * `if (labelText.isEmpty()) return`).
 *
 * `id` (a numeric Int32 id) and `now` (millis) are passed in so this stays
 * side-effect-free and testable. The shape matches the Android TaskData wire
 * format — numeric id/projectId, dueDate 0, remoteState synced, etc.
 */
export function buildConvertedTask(action, parentTask, id, now) {
  if (!parentTask) return null;
  const label = (action?.actionLabel || "").trim();
  if (!label) return null;

  return {
    id,
    title: label,
    description: "",
    projectId: toRefValue(parentTask.projectId),
    usedAsNote: false,
    feedData: true,
    labelIds: [],
    remoteState: "remote_state_synced",
    firestoreId: toDocId(id),
    updatedAt: now,
    dueDate: 0,
    taskState: parentTask.taskState || "task_state_backlog",
    estimatedTime: 0,
  };
}
